import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=67ac97de&"
import script from "./RecoverPassword.vue?vue&type=script&lang=ts&"
export * from "./RecoverPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports